export const CollapseIcon = ({
	color = 'var(--mono400)',
	width = '24',
	height = '24',
	...props
}): JSX.Element => (
	<svg
		width={width}
		height={height}
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}>
		<path
			d="M7.6875 16.3438C7.6875 16.7266 7.38672 17 7.03125 17C6.64844 17 6.375 16.7266 6.375 16.3438V7.15625C6.375 6.80078 6.64844 6.5 7.03125 6.5C7.38672 6.5 7.6875 6.80078 7.6875 7.15625V16.3438ZM13.8125 14.7852C14.0859 15.0312 14.0859 15.4414 13.8398 15.7422C13.5938 15.9883 13.1836 16.0156 12.9102 15.7695L9.19141 12.2695C8.91797 12.0234 8.91797 11.5586 9.19141 11.3125L12.9102 7.8125C13.1836 7.56641 13.5938 7.56641 13.8398 7.83984C13.9492 7.97656 14.0039 8.11328 14.0039 8.27734C14.0039 8.46875 13.9492 8.63281 13.8125 8.76953L11.2969 11.1211H17.9414C18.3242 11.1211 18.625 11.3945 18.625 11.75C18.625 12.1328 18.3242 12.4062 17.9414 12.4062H11.2969L13.8125 14.7852Z"
			fill={color}
		/>
	</svg>
)
